import { ServiceFetch } from '../service-fetch'

export default class StockChangeOutListModel extends ServiceFetch {
    getStockChangeOutListBy = (data) => this.authFetch({
        url: 'stock-change-out-list/getStockChangeOutListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}